<div class="filters-content">
    <evc-nav-button
        class="filter-btn"
        [matMenuTriggerFor]="markFilterMenu"
        type="secondary"
        variant="semi"
        leftIcon="filter"
        size="sm"
    >
        {{'inspectionlist.filter'| translate }}
    </evc-nav-button>

  @if(filterMarkControl.value?.length > 0){
    <div class="selected-marks-container">
      @for (mark of filterMarkControl.value; track mark) {
          <ng-container>
              <div class="mark-tag">
                <span [style.background-color]="getFilterMark(mark)?.color">{{getFilterMark(mark)?.code}}</span>
                {{ getFilterMark(mark)?.label }}
                  <mat-icon class="icon close-mat-icon" (click)="removeFilter(getFilterMark(mark))">close</mat-icon>
              </div>
          </ng-container>
      }
    </div>
  }
</div>

<mat-menu #markFilterMenu="matMenu">
    @for (mark of marks; track mark.identifier) {
        @if (mark.color !== MARK_DISABLED_COLOR) {
            <button mat-menu-item (click)="markFilterMenuItemClick(mark.identifier); $event.stopPropagation()">
                <mat-checkbox [checked]="filterMarkControl.value?.includes(mark.identifier)">
                    <div class="inspection-data-mark-filter-menu-checkbox">
                        <span class="inspection-data-mark-color-icon" [style.background-color]="mark.color">{{ mark.code }}</span>{{ mark.label }}
                    </div>
                </mat-checkbox>
            </button>
        }
    }

</mat-menu>
